const DATE_TIME = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'UTC',
});

const DATE_ONLY = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
});

const DATE_SHORT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

const TIME_ONLY = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'UTC',
});

/** Renders an ISO timestamp as "10 Jul 2026, 18:00" (admin-ui.md date convention). */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return DATE_TIME.format(new Date(iso));
}

/**
 * Split date/time for stacked table cells (contests-list design: date on the
 * first line, 24h time on the second).
 */
export function formatDateParts(iso: string | null | undefined): { date: string; time: string } {
  if (!iso) return { date: '—', time: '' };
  const d = new Date(iso);
  return { date: DATE_ONLY.format(d), time: TIME_ONLY.format(d) };
}

/**
 * Compact schedule-rail timestamp ("29 Jun · 09:50") — year omitted, middot
 * separator, matching the contest-overview design reference.
 */
export function formatRailDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${DATE_SHORT.format(d)} · ${TIME_ONLY.format(d)}`;
}

/**
 * Converts an `<input type="datetime-local">` value ("2026-07-18T18:00", no timezone) into a
 * full ISO 8601 date-time the backend's JSON-schema validation accepts. Treated as UTC, not the
 * browser's local timezone, for consistency with formatDateTime — every timestamp in this app
 * displays in UTC with no local-timezone conversion, so a typed wall-clock time means UTC too.
 */
export function dateTimeLocalToIso(value: string): string {
  return `${value}:00.000Z`;
}
